<template>
  <div>
    <v-dialog
      v-model="searchProductDialog"
      max-width="1000"
    >
      <v-card class="pa-4">
        <h3 class="headline font-weight-bold">Add Item</h3>
        <v-container fluid grid-list-lg class="pa-0">
          <v-layout row wrap>
            <v-flex xs4 sm3>
              <v-text-field
                label="Search for"
                v-model="txtProductName"
                @keyup.enter="getProducts(cboProductCategory, txtProductName, cboSeller)"
              ></v-text-field>
            </v-flex>
            <v-flex xs8 sm5>
              <v-select
                :items="categories"
                item-text="name"
                item-value="categoryId"
                label="Category"
                v-model="cboProductCategory"
              ></v-select>
            </v-flex>
            <v-flex xs10 sm3>
              <v-select
                :items="sellers"
                item-text="storeName"
                item-value="userId"
                label="Seller"
                v-model="cboSeller"
              ></v-select>
            </v-flex>
            <v-flex xs2 sm1>
              <v-btn
                icon
                @click="getProducts(cboProductCategory, txtProductName, cboSeller)"
              >
                <v-icon>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
        <div style="height:400px;overflow-y:auto;border:1px solid #999999;" ref="productListDiv">
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 sm4 md3 v-for="(item, index) in productListItems" :key="index">
                <v-card flat class="pa-2">
                  <v-img v-if="item.images.length > 0" :src="item.images[0].smallUrl" aspect-ratio="1.2" class="mb-2"></v-img>
                  <div v-else style="width:100%; height: 150px; border: 1px solid #333333; padding: 20px 10px; text-align: center;">No Image</div>
                  <div v-if="item.shippingSubsidies && item.shippingSubsidies.freeShipping && item.shippingSubsidies.freeShipping.isFreeShipping === '1'" style="position:absolute;top:15px;left:15px;"><img src="/static/img/free-shipping.png" style="width:55px;height:auto;" /></div>
                </v-card>
                <v-tooltip bottom offset-overflow :max-width=250>
                  <div slot="activator">{{ item.name | truncate(50) }}</div>
                  <span>{{ item.name }}</span>
                </v-tooltip>
                <div class="body-2 font-weight-bold mt-3">{{ currency.sign + formatPrice(item.retailPriceInBase / exchangeRateToBase, currency.currencyDecimals, currency.currencyDecimalSign) }}</div>
                <div class="caption font-weight-light">As low as <strong>{{ currency.sign + formatPrice(item.lowestPriceInBase / exchangeRateToBase, currency.currencyDecimals, currency.currencyDecimalSign) }}</strong></div>
                <v-btn
                  outline
                  block
                  small
                  class="mt-3"
                  @click="clickAddItem(index)"
                >
                  Add
                </v-btn>
                <div class="caption font-weight-light">By {{ item.storeName }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
        <v-container fluid grid-list-lg class="pa-2">
          <v-layout row wrap>
            <v-flex sm6 hidden-xs-only>
            </v-flex>
            <v-flex sm3 xs6>
              <v-btn
                block
                outline
                :disabled="productListOffset <= 0"
                @click="getProducts(cboProductCategory, txtProductName, cboSeller, '', (productListOffset-productListLimit <= 0 ? 0 : productListOffset-productListLimit))"
              >
                Prev
              </v-btn>
            </v-flex>
            <v-flex sm3 xs6>
              <v-btn
                block
                outline
                :disabled="productListOffset + productListLimit >= productListTotal"
                @click="getProducts(cboProductCategory, txtProductName, cboSeller, '', productListOffset+productListLimit)"
              >
                Next
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="addItemDialog"
      max-width="350"
    >
      <v-card class="pa-4">
        <h3 class="headline font-weight-bold">Add Item</h3>
        <v-form ref="frmAddItem" v-model="frmAddItemValid">
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12>
                <v-select
                  :items="addItemSkus"
                  item-text="sku"
                  item-value="sku"
                  label="SKU"
                  v-model="cboAddItemSku"
                  :rules="[v => !!v || 'SKU is required']"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 v-for="(param, paramIndex) in addItemParams" :key="paramIndex">
                <v-text-field
                  v-if="param.type === 'text'"
                  :label="param.name"
                  v-model="txtAddItemParams[paramIndex].value"
                  :rules="[v => !!v || 'Value is required']"
                  required
                ></v-text-field>
                <div v-if="param.type === 'file'" :title="param.hint">
                  <v-card flat>
                    <v-container fluid class="pa-0 mb-3">
                      <v-layout row wrap>
                        <v-flex xs12>
                          {{ param.name }}:
                        </v-flex>
                        <v-flex xs12>
                          <input
                            type="file"
                            :name="param.productParamId"
                            :ref="param.productParamId"
                            accept="*"
                            @change="onFilePicked"
                            @click="$refs[param.productParamId].value = null"
                          >
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <v-divider color="gray"></v-divider>
                  </v-card>
                </div>
                <v-select
                  v-if="param.type === 'select' && param.isMultipleSelection === '0'"
                  :items="param.selectionItems"
                  item-text="selectionDisplayName"
                  item-value="selectionName"
                  :label="param.name"
                  v-model="txtAddItemParams[paramIndex].selections[0].name"
                  :rules="[v => !!v || 'Value is required']"
                  required
                ></v-select>
                <v-select
                  v-if="param.type === 'select' && param.isMultipleSelection === '1'"
                  :items="param.selectionItems"
                  item-text="selectionDisplayName"
                  item-value="selectionName"
                  :label="param.name"
                  v-model="txtAddItemParams[paramIndex].selections"
                  multiple
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-btn
                  block
                  @click="addItemFromDialog"
                >
                  Add Item
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="220"
    >
      <loading></loading>
    </v-dialog>

  </div>
</template>

<style scoped>

</style>

<script>
import axios from 'axios'
import router from '../router'
import Loading from '@/components/Loading.vue'

export default {
  props: {
    currencyCode: {
      required: true,
      type: String
    },
    exchangeRateToBase: {
      required: true,
      type: Number
    },
    mode: {
      required: false,
      type: String,
      default: 'sku',
      validator (value) {
        // The value must match one of these strings
        return ['product', 'sku'].includes(value)
      }
    },
    autoClose: {
      required: false,
      type: Boolean,
      default: true
    }
  },

  components: {
    Loading
  },

  data () {
    return {
      def: this.$store.getters.getDef,
      loading: false,
      customCallbackData: {},
      currency: {},
      searchProductDialog: false,
      cboSeller: '',
      sellers: [],
      cboProductCategory: '',
      txtProductName: '',
      categories: [],
      productListItems: [],
      productListLimit: 10,
      productListOffset: 0,
      productListTotal: 0,
      addItemDialog: false,
      addItemProductIndex: null,
      frmAddItemValid: false,
      cboAddItemSku: '',
      txtAddItemParams: [],
      addItemSkus: [],
      addItemParams: [],
      addItemFiles: []
    }
  },

  mounted () {
    this.getCurrency()
    this.getCategories()
    this.getSellers()
  },

  methods: {
    show: function (customData) {
      this.customCallbackData = customData
      this.searchProductDialog = true
    },
    addItem: function (product) {
      if (this.customCallbackData !== null) {
        product.customData = this.customCallbackData
      }
      this.$emit('product-added', product)
      if (this.autoClose === true) {
        this.searchProductDialog = false
      }
    },
    clickAddItem: function (productIndex) {
      if (this.mode === 'product') {
        this.addItem({
          url: this.def.marketplaceDomain + '/' + this.productListItems[productIndex].permalink + '.html',
          permalink: this.productListItems[productIndex].permalink,
          image: this.productListItems[productIndex].image,
          images: this.productListItems[productIndex].images,
          itemParams: [],
          name: this.productListItems[productIndex].name,
          options: [],
          productId: this.productListItems[productIndex].productId,
          qty: 1,
          remarks: '',
          sku: this.productListItems[productIndex].skus[0].sku,
          currentRetailQtyPricingInBase: this.formatSkuQtyPricing(this.productListItems[productIndex].skus[0].retailQtyPricing),
          sellerUserId: this.productListItems[productIndex].sellerUserId,
          storeCountryId: this.productListItems[productIndex].storeCountryId,
          storeCountryName: this.productListItems[productIndex].storeCountryName,
          storeName: this.productListItems[productIndex].storeName,
          storeType: this.productListItems[productIndex].storeType,
          storeParentId: this.productListItems[productIndex].storeParentId,
          storeParentName: this.productListItems[productIndex].storeParentName,
          storeParentType: this.productListItems[productIndex].storeParentType,
          unitPrice: this.productListItems[productIndex].retailPriceInBase / this.exchangeRateToBase,
          unitPriceInBase: this.productListItems[productIndex].retailPriceInBase,
          unitWeight: this.productListItems[productIndex].weight,
          shippingSubsidies: this.productListItems[productIndex].shippingSubsidies
        })
      } else if (this.mode === 'sku') {
        if (this.productListItems[productIndex].skus.length > 1) {
          this.showAddItemDialog(productIndex)
        } else if (this.productListItems[productIndex].params.length > 0) {
          this.showAddItemDialog(productIndex)
        } else {
          // can add directly
          this.addItem({
            url: this.def.marketplaceDomain + '/' + this.productListItems[productIndex].permalink + '.html',
            permalink: this.productListItems[productIndex].permalink,
            image: this.productListItems[productIndex].image,
            images: this.productListItems[productIndex].images,
            itemParams: [],
            name: this.productListItems[productIndex].name,
            options: [],
            productId: this.productListItems[productIndex].productId,
            qty: 1,
            remarks: '',
            sku: this.productListItems[productIndex].skus[0].sku,
            currentRetailQtyPricingInBase: this.formatSkuQtyPricing(this.productListItems[productIndex].skus[0].retailQtyPricing),
            sellerUserId: this.productListItems[productIndex].sellerUserId,
            storeCountryId: this.productListItems[productIndex].storeCountryId,
            storeCountryName: this.productListItems[productIndex].storeCountryName,
            storeName: this.productListItems[productIndex].storeName,
            storeType: this.productListItems[productIndex].storeType,
            storeParentId: this.productListItems[productIndex].storeParentId,
            storeParentName: this.productListItems[productIndex].storeParentName,
            storeParentType: this.productListItems[productIndex].storeParentType,
            unitPrice: this.productListItems[productIndex].retailPriceInBase / this.exchangeRateToBase,
            unitPriceInBase: this.productListItems[productIndex].retailPriceInBase,
            unitWeight: this.productListItems[productIndex].weight,
            shippingSubsidies: this.productListItems[productIndex].shippingSubsidies
          })
        }
      }
    },
    showAddItemDialog: function (productIndex) {
      this.$refs.frmAddItem.reset()
      this.addItemFiles = []
      this.addItemProductIndex = productIndex
      this.addItemSkus = this.productListItems[productIndex].skus
      var i, j
      var params = []
      params = this.deepCopy(this.productListItems[productIndex].params)
      for (i in params) {
        if (params[i].type === 'select') {
          for (j in params[i].selectionItems) {
            params[i].selectionItems[j].selectionDisplayName = params[i].selectionItems[j].selectionName + ' (' + this.currency.sign + this.formatPrice(params[i].selectionItems[j].priceInBase / this.exchangeRateToBase, this.currency.currencyDecimals, this.currency.currencyDecimalSign) + ')'
          }
        }
      }

      this.addItemParams = params
      if (this.addItemSkus.length === 1) {
        this.cboAddItemSku = this.addItemSkus[0].sku
      } else {
        this.cboAddItemSku = ''
      }
      this.txtAddItemParams = []
      for (i in this.productListItems[productIndex].params) {
        if (this.productListItems[productIndex].params[i].type === 'text' || this.productListItems[productIndex].params[i].type === 'file') {
          this.txtAddItemParams.push({
            name: this.productListItems[productIndex].params[i].name,
            value: ''
          })
        } else if (this.productListItems[productIndex].params[i].type === 'select') {
          if (this.productListItems[productIndex].params[i].isMultipleSelection === '0') {
            this.txtAddItemParams.push({
              name: this.productListItems[productIndex].params[i].name,
              selections: [{
                name: ''
              }]
            })
          } else {
            this.txtAddItemParams.push({
              name: this.productListItems[productIndex].params[i].name,
              selections: []
            })
          }
        }
      }
      this.addItemDialog = true
      this.frmAddItemValid = false
      this.$refs.frmAddItem.validate()
    },
    addItemFromDialog: async function () {
      if (this.cboAddItemSku.length === 0) {
        window.alert('Please select product SKU')
        return false
      }

      // get options
      this.loading = true
      var options = []
      var targetItem = this.deepCopy(this.productListItems[this.addItemProductIndex])
      var productImage = targetItem.image
      var i, j, k, selectionName
      var targetItemQtyPricing = []
      var targetItemPriceInBase = 0

      for (i in targetItem.skus) {
        if (targetItem.skus[i].sku === this.cboAddItemSku) {
          targetItemPriceInBase = targetItem.skus[i].retailPriceInBase
          targetItemQtyPricing = targetItem.skus[i].retailQtyPricing
          options = this.deepCopy(targetItem.skus[i].options)

          // inject sku image if available
          if (targetItem.skus[i].productImageId.length > 0) {
            productImage = targetItem.skus[i].imageSmallUrl
          }
          break
        }
      }

      var paramPriceInBase = 0
      var paramWeight = 0
      for (i in targetItem.params) {
        // inject price into params selections
        if (targetItem.params[i].type === 'select') {
          if (targetItem.params[i].isMultipleSelection === '1') {
            // find prices for each selection
            for (j in targetItem.params[i].selectionItems) {
              for (k in this.txtAddItemParams[i].selections) {
                if (typeof this.txtAddItemParams[i].selections[k] === 'string') {
                  selectionName = this.txtAddItemParams[i].selections[k]
                  if (targetItem.params[i].selectionItems[j].selectionName === selectionName) {
                    this.txtAddItemParams[i].selections[k] = {
                      name: selectionName,
                      price: targetItem.params[i].selectionItems[j].priceInBase / this.exchangeRateToBase,
                      priceInBase: targetItem.params[i].selectionItems[j].priceInBase,
                      weight: targetItem.params[i].selectionItems[j].weight
                    }
                    paramPriceInBase += Number(this.txtAddItemParams[i].selections[k].priceInBase)
                    paramWeight += Number(this.txtAddItemParams[i].selections[k].weight)

                    // inject param image if available
                    if (targetItem.params[i].selectionItems[j].productImageId.length > 0) {
                      productImage = targetItem.params[i].selectionItems[j].imageSmallUrl
                    }
                  }
                }
              }
            }
          } else if (targetItem.params[i].isMultipleSelection === '0') {
            // find prices for each selection
            for (j in targetItem.params[i].selectionItems) {
              for (k in this.txtAddItemParams[i].selections) {
                console.log(targetItem.params[i].selectionItems[j].selectionName + '===' + this.txtAddItemParams[i].selections[k].name)
                if (targetItem.params[i].selectionItems[j].selectionName === this.txtAddItemParams[i].selections[k].name) {
                  this.txtAddItemParams[i].selections[k].price = targetItem.params[i].selectionItems[j].price
                  this.txtAddItemParams[i].selections[k].priceInBase = targetItem.params[i].selectionItems[j].priceInBase
                  this.txtAddItemParams[i].selections[k].weight = targetItem.params[i].selectionItems[j].weight
                  paramPriceInBase += this.txtAddItemParams[i].selections[k].priceInBase
                  paramWeight += this.txtAddItemParams[i].selections[k].weight

                  // inject param image if available
                  if (targetItem.params[i].selectionItems[j].productImageId.length > 0) {
                    productImage = targetItem.params[i].selectionItems[j].imageSmallUrl
                  }
                  break
                }
              }
            }
          }
        } else if (targetItem.params[i].type === 'file') {
          // upload file
          var isFileFound = false
          for (j in this.addItemFiles) {
            if (this.addItemFiles[j].productParamId === targetItem.params[i].productParamId) {
              console.log(this.addItemFiles[j])
              isFileFound = true
              break
            }
          }
          if (isFileFound) {
            let fileUrl = await this.uploadFile(this.addItemFiles[j].fileContent)
            this.txtAddItemParams[i].value = fileUrl
          } else {
            this.loading = false
            window.alert('Invalid uploaded file')
            return false
          }
        }
      }
      console.log(targetItem.params)
      console.log('param price in base: ' + paramPriceInBase)

      // add into order
      this.addItem({
        url: this.def.marketplaceDomain + '/' + targetItem.permalink + '.html',
        permalink: targetItem.permalink,
        image: productImage,
        images: targetItem.images,
        itemParams: this.deepCopy(this.txtAddItemParams),
        name: targetItem.name,
        options: options,
        productId: targetItem.productId,
        qty: 1,
        remarks: '',
        sku: this.cboAddItemSku,
        currentRetailQtyPricingInBase: this.formatSkuQtyPricing(targetItemQtyPricing),
        sellerUserId: targetItem.sellerUserId,
        storeCountryId: targetItem.storeCountryId,
        storeCountryName: targetItem.storeCountryName,
        storeName: targetItem.storeName,
        storeType: targetItem.storeType,
        storeParentId: targetItem.storeParentId,
        storeParentName: targetItem.storeParentName,
        storeParentType: targetItem.storeParentType,
        unitPrice: (targetItemPriceInBase + paramPriceInBase) / this.exchangeRateToBase,
        unitPriceInBase: targetItemPriceInBase + paramPriceInBase,
        unitWeight: targetItem.weight + paramWeight,
        shippingSubsidies: targetItem.shippingSubsidies
      })
      this.addItemDialog = false
      this.loading = false
    },
    formatSkuQtyPricing: function (qtyPricingArray) {
      var result = []
      for (var i in qtyPricingArray) {
        result.push({
          qty: qtyPricingArray[i].qty,
          price: qtyPricingArray[i].priceInBase
        })
      }
      return result
    },
    getCategories: function () {
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/categories')
        .then(resp => {
          console.log(resp.data)
          if (resp.data.status === 'success') {
            var categories = [
              {
                name: 'All',
                categoryId: ''
              }
            ]
            var result = this.generateCategoryListRecursive(resp.data.data, categories, 0)
            this.categories = this.categories.concat(result)
          } else {
            console.log('unable to load categories: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
          }
        })
    },
    generateCategoryListRecursive: function (inputCategories, output, level) {
      var strPad = ''
      for (var j = 0; j < level; j++) {
        strPad = strPad + '----'
      }
      for (var i = 0; i < inputCategories.length; i++) {
        inputCategories[i].level = level
        inputCategories[i].name = strPad + ' ' + inputCategories[i].name
        output.push(inputCategories[i])
        if (inputCategories[i].childs.length > 0) {
          output = this.generateCategoryListRecursive(inputCategories[i].childs, output, level + 1)
        }
      }
      return output
    },
    getCurrency: function () {
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/currency/' + this.currencyCode)
        .then(resp => {
          console.log(resp.data)
          if (resp.data.status === 'success') {
            resp.data.data.exchangeRateToBase = this.exchangeRateToBase
            this.currency = resp.data.data
          } else {
            console.log('unable to load currency: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
          }
        })
    },
    getSellers: function () {
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/users?type=seller,virtual,franchise,branch&limit=100')
        .then(resp => {
          console.log(resp.data)
          if (resp.data.status === 'success') {
            this.sellers = resp.data.data
          } else {
            console.log('unable to load sellers: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
          }
        })
    },
    getProducts: function (categoryId = '', name = '', seller = '', sort = '', offset = 0) {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/products?category_id=' + categoryId + '&name=' + encodeURIComponent(name) + '&seller=' + seller + '&sort=' + sort + '&offset=' + offset + '&limit=8')
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              for (var c in resp.data.data) {
                if (resp.data.data[c].images.length > 0) {
                  resp.data.data[c].image = resp.data.data[c].images[0].smallUrl
                } else {
                  resp.data.data[c].image = ''
                }
              }
              _this.productListItems = resp.data.data
              _this.productListLimit = resp.data.limit
              _this.productListOffset = resp.data.offset
              _this.productListTotal = resp.data.total

              this.$nextTick(() => {
                this.$refs.productListDiv.scrollTop = 0
              })
            } else {
              console.log('unable to load products: ' + resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })

      return promise
    },

    onFilePicked: function (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.addItemFiles.push({
            productParamId: e.srcElement.name,
            localUrl: fr.result,
            fileContent: files[0] // this is the file content that can be sent to server...
          })
        })
      }
    },
    uploadFile: async function (file) {
      let formData = new FormData()
      formData.append('file', file, file.name)
      var resultUrl = ''
      await axios.post(process.env.VUE_APP_API_ROOT + '/v1/sales/upload',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
        .then(resp => {
          if (resp.data.status === 'success') {
            this.loading = false
            var url = resp.data.data.url
            console.log(url)
            resultUrl = url
          } else {
            window.alert('unable to upload file: ' + resp.data.message)
            this.loading = false
          }
        })
        .catch(function (error) {
          if (error.response) {
            window.alert(error.response.status)
          }
          this.loading = false
        })

      if (resultUrl.length > 0) {
        return resultUrl
      } else {
        return false
      }
    }

  }
}

</script>
